<template>
  <div
    class="projectInfoWrapper textStyleProject"
    @click="openAudios(folderInfo.id)"
  >
    <div class="projectNameWrapper">
      <div class="projectIconWrapper">
        <slot />
      </div>
      <div class="projectNameStyle">{{ folderName }}</div>
      <div class="fi-tooltipInfo">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div style="width: 19px; height: 19px" v-on="on" v-bind="attrs">
              <InfoIcon />
            </div>
          </template>
          <div>{{ $t("folderInfo.createDate") }} {{ getFormatDate }}</div>
          <div>
            {{ $t("folderInfo.totalTranslated") }}
            {{ folderInfo.total_synthesized }}
          </div>
          <div>{{ $t("folderInfo.audio") }} {{ folderInfo.audiosCount }}</div>
        </v-tooltip>
      </div>
    </div>
    <div class="totalTime">{{ folderInfo.total_synthesized }}</div>
    <div class="created_date">{{ getFormatDate }}</div>
    <div class="audiosCount">{{ folderInfo.audiosCount }}</div>
    <v-spacer></v-spacer>
    <div class="otherThingsWrapper">
      <v-btn class="showBtn" @click="openAudios(folderInfo.id)">{{
        $t("folderInfo.openFolder")
      }}</v-btn>
      <v-menu bottom left min-width="140px" max-width="140px" offset-y>
        <template v-slot:activator="{ on }">
          <v-btn class="thingsBtn" v-on="on"><MenuIcon /></v-btn>
        </template>
        <v-list>
          <v-list-item-content class="align-center">
            <v-dialog v-model="editDialog" persistent max-width="500">
              <template v-slot:activator="{ on, attrs }">
                <v-list-item class="listItem" v-bind="attrs" v-on="on">
                  <EditIcon :width="18" :height="18" />
                  <div class="editName">{{ $t("folderInfo.changeName") }}</div>
                </v-list-item>
              </template>
              <v-card class="dialogWrapper">
                <div class="dialogTitleWrapper">
                  <EditIcon />
                  <div class="dialogTitle">
                    {{ $t("folderInfo.changeFolderNameDialogTitle") }}
                  </div>
                </div>
                <div class="dialogWarn">
                  {{ $t("folderInfo.enterNewFolderName") }}
                </div>
                <div class="createInputWrapper">
                  <input
                    type="text"
                    autocomplete="off"
                    :placeholder="$t('folderInfo.newFolderNamePlaceholder')"
                    name="editName"
                    v-model="editName"
                  />
                  <span v-if="inputError == true" class="fi-errorInput">{{
                    inputErrorText
                  }}</span>
                </div>
                <div class="dialogActionWrapper">
                  <v-btn
                    color="darken-1"
                    class="closeBtn"
                    text
                    @click="closeDialog"
                    >{{ $t("folderInfo.closeButton") }}</v-btn
                  >
                  <v-btn
                    class="createBtn"
                    text
                    @click="editFolderName"
                    :loading="this.loading"
                    >{{ $t("folderInfo.changeButton") }}</v-btn
                  >
                </div>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialog" persistent max-width="380">
              <template v-slot:activator="{ on, attrs }">
                <v-list-item v-bind="attrs" v-on="on">
                  <DeleteIcon :width="18" :height="18" color="#d23636" />
                  <div class="deleteProject">
                    {{ $t("folderInfo.deleteFolder") }}
                  </div>
                </v-list-item>
              </template>
              <v-card class="dialogWrapper">
                <div class="dialogRemoveTitleWrapper">
                  <DeleteIcon />
                  <div class="dialogRemoveTitle">
                    {{ $t("folderInfo.deleteFolderDialogTitle") }}
                  </div>
                </div>
                <div class="dialogRemoveQuestion">
                  {{ $t("folderInfo.deleteFolderWarningMessage") }}
                </div>
                <div class="dialogActionWrapper">
                  <v-btn
                    color="darken-1"
                    class="closeBtn"
                    text
                    @click="closeDialog"
                    >{{ $t("folderInfo.closeButton") }}</v-btn
                  >
                  <v-btn
                    class="removeBtn"
                    text
                    @click="removeFolder"
                    :loading="this.loading"
                    >{{ $t("folderInfo.deleteFolderYesButton") }}</v-btn
                  >
                </div>
              </v-card>
            </v-dialog>
          </v-list-item-content>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>
<script>
import { format } from "date-fns";
import axios from "axios";

import MenuIcon from "../components/icons/MenuIcon";
import EditIcon from "../components/icons/EditIcon";
import DeleteIcon from "../components/icons/DeleteIcon";
import InfoIcon from "../components/icons/InfoIcon";
import { mapActions } from "vuex";
export default {
  name: "FolderInfo",
  components: { MenuIcon, DeleteIcon, EditIcon, InfoIcon },
  data: () => ({
    dialog: false,
    editDialog: false,
    loading: false,
    folderName: "",
    editName: "",
    inputErrorText: "",
    inputError: false,
  }),
  props: {
    folderInfo: {
      name: String,
      time: String,
      id: Number,
      created_date: Number,
      audiosCount: Number,
      total_synthesized: Number,
    },
    whereToOpen: String,
    updateList: { type: Function },
  },
  created() {
    this.folderName = this.folderInfo.name;
  },
  computed: {
    getToken: function() {
      return this.$cookie.get("token");
    },
    getFormatDate: function() {
      var currentDate = new Date(this.folderInfo.created_date);
      currentDate.setHours(currentDate.getHours());
      return format(currentDate, "yyyy/MM/dd HH:mm");
    },
  },
  watch: {
    editDialog: function() {
      if (this.editDialog) {
        this.editName = this.folderName;
      }
    },
    editName: function() {
      this.inputValidate();
    },
  },
  methods: {
    ...mapActions([
      "showWarningMessage",
      "showSuccessMessage",
      "showErrorMessage",
      "checkError",
    ]),
    removeFolder() {
      const headers = {
        token: this.getToken,
      };
      this.loading = true;
      axios
        .delete(
          `${process.env.VUE_APP_BASE_URL}/v2/group/${this.folderInfo.id}`,
          { headers }
        )
        .then((response) => {
          if (response.status === 200) {
            this.showSuccessMessage({
              message: this.$t("folderInfo.successMsg1"),
              timeout: 3000,
            });
            this.updateList();
          }
          this.loading = false;
          this.closeDialog();
        })
        .catch((error) => {
          this.loading = false;
          this.closeDialog();
          this.checkError(error);
        });
    },
    editFolderName() {
      if (this.inputValidate()) {
        const headers = {
          token: this.getToken,
        };
        this.loading = true;
        axios
          .put(
            `${process.env.VUE_APP_BASE_URL}/v2/group/${this.folderInfo.id}/name`,
            this.editName,
            { headers }
          )
          .then((response) => {
            if (response.status === 200) {
              this.showSuccessMessage({
                message: this.$t("folderInfo.successMsg2"),
                timeout: 3000,
              });
              this.folderName = this.editName;
            }
            this.loading = false;
            this.closeDialog();
          })
          .catch((error) => {
            this.loading = false;
            this.closeDialog();
            this.checkError(error);
          });
      }
    },
    /* Тухайн эдитор дээр оруулсан зүйлүүдийг шалгах функц */
    inputValidate() {
      if (this.editName.length == 0) {
        this.inputErrorText = this.$t("folderInfo.enterNameWarningMsg");
        this.inputError = true;
        return false;
      } else if (this.editName.length > 21) {
        this.inputErrorText = this.$t("folderInfo.validateNameWarningMsg");
        this.inputError = true;
        return false;
      } else {
        this.inputError = false;
        return true;
      }
    },
    openAudios(id) {
      event.stopPropagation();
      this.$router
        .push({
          name: this.whereToOpen,
          params: { folderId: id },
        })
        .catch((err) => {
          console.log(err);
        });
    },
    closeDialog() {
      this.editName = "";
      this.inputError = false;
      this.inputErrorText = "";
      this.dialog = false;
      this.editDialog = false;
    },
  },
};
</script>

<style>
.projectInfoWrapper {
  display: flex;
  width: 100%;
  height: 65px;
  align-items: center;
  transition: 0.2s ease-out;
  border-bottom: 1px solid #e8ebed;
  cursor: pointer;
}

.projectInfoWrapper:hover {
  background-color: #f8f8f8;
  transition: 0.2s ease-out;
}

.textStyleProject {
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: #000000;
  text-align: left;
}

.projectNameWrapper {
  display: flex;
  width: 25%;
  min-width: 200px;
  margin-right: 30px;
  padding-left: 10px;
  align-items: center;
}

.projectNameStyle {
  max-width: 121px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 10px;
}

.projectIconWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  min-height: 40px;
  background-color: #eff0fd;
  border-radius: 3px;
  margin-right: 10px;
}

.totalTime {
  min-width: 133px;
  margin-right: 30px;
}

.created_date {
  min-width: 135px;
  margin-right: 30px;
}

.audiosCount {
  min-width: 89px;
  margin-right: 30px;
}

.otherThingsWrapper {
  width: auto;
  display: flex;
  justify-content: flex-end;
  padding-right: 10px;
}

.showBtn {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676 !important;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 5px;
  height: 34px !important;
  width: 64px !important;
}

.thingsBtn {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676 !important;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 5px;
  height: 34px !important;
  min-width: 34px !important;
  padding: 0 !important;
}

.thingsBtn:hover {
  border: 2px solid #e5e5e5;
}

.fi-tooltipInfo {
  display: none;
}
@media screen and (max-width: 900px) {
  .projectNameWrapper {
    width: 70%;
  }
  .fi-tooltipInfo {
    display: block;
  }

  .otherThingsWrapper {
    width: 30%;
  }
  .audiosCount,
  .created_date,
  .totalTime {
    display: none;
  }
}

.v-menu__content {
  border: 1px solid #e5e5e5 !important;
  background-color: #ffffff;
  border-radius: 6px !important;
  box-shadow: none !important;
  padding-top: 0 !important;
  box-shadow: 0px 9px 16px rgba(0, 0, 0, 0.06) !important;
}

.v-list {
  padding: 0;
}

.v-list-item__content {
  padding: 0;
}

.listItem {
  border-bottom: 1px solid #e5e5e5;
}

.editName {
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: #000000;
  margin-left: 10px;
}

.deleteProject {
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: #d23636;
  margin-left: 10px;
}

.dialogWrapper {
  padding: 31px 38px;
}

@media screen and (max-width: 768px) {
  .dialogWrapper {
    padding: 20px;
  }
}

.dialogTitleWrapper {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.dialogRemoveTitleWrapper {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  color: #d23636;
}

.dialogRemoveQuestion {
  font-size: 14px;
  line-height: 16px;
  color: #767676;
}

.folderIconWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  min-height: 40px;
  background-color: #eff0fd;
  border-radius: 3px;
  margin-right: 10px;
}

.dialogTitle {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  margin-left: 10px;
}

.dialogRemoveTitle {
  font-size: 16px;
  font-weight: 500;
  color: #d23636;
  margin-left: 10px;
  line-height: 18px;
}

.dialogWarn {
  font-size: 14px;
  font-weight: 500;
  color: #767676;
  margin-bottom: 10px;
}

.createInputWrapper {
  display: flex;
  position: relative;
  flex-direction: column;
  height: 56px;
}
.createInputWrapper input[type="text"] {
  height: 40px !important;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 14px;
  font-weight: 400;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  float: left;
  width: 100%;
  background-color: #ffffff;
  line-height: 16px;
  transition: 0.4s ease-out;
}

.createInputWrapper input[type="text"]:focus {
  border: 2px solid #777ff6 !important;
  outline: none;
}

.createInputWrapper input[type="text"]:hover {
  border: 2px solid #777ff6 !important;
  transition: 0.4s ease-out;
  outline: none;
}

.fi-errorInput {
  font-size: 12px;
  line-height: 14px;
  color: red;
  margin: 2px 0 0 10px;
}

.dialogActionWrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

.closeBtn {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676 !important;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 15px;
  height: 34px !important;
  width: 64px !important;
}

.removeBtn {
  background-color: #d23636 !important;
  text-transform: initial;
  color: #ffffff !important;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 5px;
  height: 34px !important;
  width: 64px !important;
}

.createBtn {
  background-color: #777ff6 !important;
  text-transform: initial;
  color: #ffffff !important;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 5px;
  height: 34px !important;
  width: 64px !important;
}
</style>
